// src/PublicMicrositeApp.tsx
//
// Minimal app shell for public microsite pages served at bandjerry.page/{slug}.
// No React Router, no Amplify, no TanStack Query, no Zustand — just reads the
// slug from the URL path and renders the public page component.

import PublicMicrositePage from '@/pages/PublicMicrositePage';

function extractSlug(): string {
  // URL is bandjerry.page/{slug} — strip leading slash
  const path = window.location.pathname;
  const slug = path.replace(/^\/+/, '').replace(/\/+$/, '');
  return slug;
}

export default function PublicMicrositeApp() {
  const slug = extractSlug();

  if (!slug) {
    // Root path with no slug — redirect to main site
    window.location.href = 'https://www.bandjerry.com';
    return null;
  }

  return <PublicMicrositePage slug={slug} />;
}
